import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { useFlagsService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import { PACKAGE_NAME, TEAM_NAME, ERROR_ID } from './constants.tsx';
import messages from './messages.tsx';

export const useClipboardError = () => {
	const { formatMessage } = useIntl();
	const { showFlag, dismissFlag } = useFlagsService();

	return useCallback(
		(error: Error) => {
			fireErrorAnalytics({
				meta: {
					id: ERROR_ID,
					packageName: PACKAGE_NAME,
					teamName: TEAM_NAME,
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});

			const flagId = showFlag({
				type: 'error',
				title: formatMessage(messages.errorFlagTitle),
				description: formatMessage(messages.errorFlagDescription),
				actions: [
					{
						content: formatMessage(messages.errorFlagContactSupportActionText),
						href: 'https://support.atlassian.com/contact',
						target: '_blank',
						onClick: () => flagId && dismissFlag(flagId),
					},
				],
			});
		},
		[showFlag, dismissFlag, formatMessage],
	);
};
